import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import OrderFormOption from "@/entities/orderFormOption.entity.js";

/**
 * Order Form Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.orderFormOption = new OrderFormOption();
    this.getSecularNameSuffixes = getSecularNameSuffixes.bind(this);
    this.getBuddhistNameCodes = getBuddhistNameCodes.bind(this);
  }
  get write () {
    return this.orderFormOption.write;
  }
  get carve () {
    return this.orderFormOption.carve;
  }
  get printTypes () {
    return this.orderFormOption.printTypes;
  }
  get fontsForCarve () {
    return this.orderFormOption.fontsForCarve;
  }
  get fontsAll () {
    return this.orderFormOption.fontsAll;
  }
  get colorsForFront () {
    return this.orderFormOption.colorsForFront;
  }
  get colorsForBack () {
    return this.orderFormOption.colorsForBack;
  }
  get sects () {
    return this.orderFormOption.sects;
  }
  get diedCharacters () {
    return this.orderFormOption.diedCharacters;
  }
  get ageAtDeathPrefixes () {
    return this.orderFormOption.ageAtDeathPrefixes;
  }
  get ageUnitCharacters () {
    return this.orderFormOption.ageUnitCharacters;
  }
  get underCharactersPlacement () {
    return this.orderFormOption.underCharactersPlacement;
  }
  get underCharacters () {
    return this.orderFormOption.underCharacters;
  }
  get secularNamePrefixPlacement () {
    return this.orderFormOption.secularNamePrefixPlacement;
  }
  get ageAtDeathPrefixPlacement () {
    return this.orderFormOption.ageAtDeathPrefixPlacement;
  }
  async listSecularNameSuffixes () {
    await this.adapter.init();
    const res = await this.getSecularNameSuffixes();
    return res.data.secularNameSuffixes;
  }
  async listBuddhistNameCodes (value) {
    let options = {};
    options.productVariationId = value;
    await this.adapter.init();
    const res = await this.getBuddhistNameCodes(options);
    return res.data.buddhistNameCodes;
  }
}

function getSecularNameSuffixes () {
  const query = `
  {
    secularNameSuffixes {
      id
      imageUrl
    }
  }`;
  return this.adapter.query(query);
}

// eslint-disable-next-line no-unused-vars
function getBuddhistNameCodes (options) {
  const query = `
  query buddhistNameCodes($productVariationId: ID!) {
    buddhistNameCodes(productVariationId: $productVariationId) {
      productVariationId,
      printType,
      font,
      textColor,
      compatibleTextColors
    }
  }`;
  return this.adapter.query(query, options);
}
